import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
    console.error('API_URL not found in environment variables!');
}

const apiClient = axios.create({
    baseURL: API_URL,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    withCredentials: true
});

apiClient.interceptors.request.use(
    (config) => {
        // Don't add auth headers for auth-related endpoints
        if (config.url.includes('/auth/register/') || 
            config.url.includes('/auth/login/') ||
            config.url.includes('/verify-email/') ||
            config.url.includes('/resend-verification/') ||
            config.url.includes('/auth/google/callback/') ||
            config.url.includes('/auth/check-email/')) {
            return config;
        }
        
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshToken = localStorage.getItem('refresh_token');
                
                if (!refreshToken) {
                    localStorage.clear();
                    return Promise.reject(error);
                }

                const response = await axios.post(
                    `${API_URL}/api/users/auth/token/refresh/`,
                    {
                        refresh: refreshToken
                    }
                );

                const { access } = response.data;

                localStorage.setItem('access_token', access);
                originalRequest.headers.Authorization = `Bearer ${access}`;

                return apiClient(originalRequest);
            } catch (refreshError) {
                localStorage.clear();
                return Promise.reject(refreshError);
            }
        }

        if (error.response?.status === 404 && error.config.url.includes('/api/users/')) {
            localStorage.clear();
        }

        return Promise.reject(error);
    }
);

export default apiClient;
